export default class GetProposalContentError extends Error {
}
